import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StoreListDTO } from '../../../../reports/models/report-models';

@Component({
  selector: 'app-store-state-modal',
  templateUrl: './store-state-modal.component.html',
  styleUrl: './store-state-modal.component.css'
})
export class StoreStateModalComponent {
  @Input() showModal: boolean = false;
  @Input() stores: any[] = [];
  @Input() isNewProject: boolean = true;  

  @Output() saveAndNotify = new EventEmitter<void>();
  @Output() closeModal = new EventEmitter<void>();

  onSaveAndNotify(): void {
    this.saveAndNotify.emit();
  }

  onClose() {
    this.closeModal.emit();
  }
}
